import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

import * as ContactUtils from "../../Utils/ContactUtils";
import Card from "../../UI/Card/Card";

const Historic = () => {

    const intl = useIntl();
    const user = useSelector(state => state.contacts.user);

    const createdDate = intl.formatDate(ContactUtils.getCreatedDate(user), { year: "numeric", month: "short", day: "numeric" });

    let developerSince = null;
    if (ContactUtils.isDeveloper(user)) {
        developerSince = intl.formatDate(ContactUtils.getDeveloperSince(user), { year: "numeric", month: "short", day: "numeric" });
    }
    
    return (
        <Card title={intl.messages.history}>
            <table className="table">
                <tbody>
                    <tr>
                        <td className="table-label">{intl.messages.createdOn}:</td>
                        <td className="table-value text-right">{createdDate}</td>
                    </tr>
                    {developerSince &&
                        <tr>
                            <td className="table-label">{intl.messages.developerSince}:</td>
                            <td className="table-value text-right">{developerSince}</td>
                        </tr>
                    }
                </tbody>

            </table>
        </Card>
    );
}

export default Historic;